import axios from "@/plugins/axios";


export default {
  getUserPayType(data){  // 获取用户是否为付费学员 false 非付费 true 付费学员
     return axios.post('order/userPayType',data)
  },

}